import { useRef, useState } from 'react';
import { Image, Carousel } from 'antd';
import ICArrows from './../../acsset/ic-next.png';
import ICDong from './../../acsset/ic-dong.png';

const ViewImageAndFile = ({ listImage, isMobile, ActionList, code }) => {
    const [idxDelete, setIdxDelete] = useState(0);
    const carouselRef = useRef();
    const next = () => carouselRef.current.next();
    const prev = () => carouselRef.current.prev();
    return (
        <div style={{ position: 'relative' }}>
            <Carousel afterChange={(e) => { setIdxDelete(e); }} ref={carouselRef} dots={true} adaptiveHeight>
                {
                    (listImage || []).map((item, index) => (
                        <>
                            <Image
                                key={index}
                                // preview={false}
                                width={'100%'}
                                // height={isMobile ? 135 : 168}
                                style={{ objectFit: 'cover', borderRadius: 12, aspectRatio: '1 / 1'}}
                                src={URL?.createObjectURL(item)}
                            />
                        </>
                    ))
                }
            </Carousel>
            {
                listImage.length > 1 &&
                <>
                    <img onClick={prev} src={ICArrows} style={{
                        position: 'absolute',
                        top: '47%',
                        left: 5,
                        width: 20,
                        color: '#333',
                        cursor: 'pointer',
                        boxShadow: '0 0 15px rgba(0, 0, 0, 0.3)',
                        borderRadius: '50%'
                    }} />
                    <img onClick={next} src={ICArrows} style={{
                        position: 'absolute',
                        top: '47%',
                        right: 5,
                        width: 20,
                        color: '#333',
                        cursor: 'pointer',
                        rotate: "180deg",
                        boxShadow: '0 0 15px rgba(0, 0, 0, 0.3)',
                        borderRadius: '50%'
                    }} />
                </>
            }
            <>
                <img onClick={() => {
                    setTimeout(() => {
                        ActionList("delete", null, { code: code, imgIndex: (idxDelete || 0) });
                        setTimeout(() => {
                            carouselRef.current?.goTo(0);
                        }, 100);
                    }, 100)
                }} src={ICDong} width={isMobile ? 20 : 24} style={{ position: 'absolute', right: isMobile ? 5 : 10, top: isMobile ? 5 : 10, cursor: 'pointer' }} />
            </>
        </div>
    )
};

export default ViewImageAndFile;